import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import type { SecondaryNavCompactToggleEvent } from "@/components/shell/shell";
import EkoElement from "@/utilities/element";
import style from "./secondary-nav-item.css?inline";

@customElement("eko-secondary-nav-item")
class NavigationItem extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true, type: Boolean }) active = false;
  @property({ reflect: true, type: Boolean }) compact: boolean = false;
  @property() href?: string;
  @property() icon: string = "mail";
  setCompact = (event: SecondaryNavCompactToggleEvent) => {
    this.compact = event.detail.compact;
  };

  @property() target?: "_self" | "_blank" | "_parent" | "_top";

  @property() tooltip?: string;

  connectedCallback(): void {
    super.connectedCallback();

    document.addEventListener("secondary-nav:compact:toggle", this.setCompact);
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();

    document.removeEventListener("secondary-nav:compact:toggle", this.setCompact);
  }

  render() {
    let menuItem = html`<eko-menu-item
      ?active=${this.active}
      href=${ifDefined(this.href)}
      target=${ifDefined(this.target)}
      ?compact=${this.compact}>
      <eko-icon slot="before" name=${this.icon} size="md"></eko-icon>
      <slot></slot>
    </eko-menu-item>`;

    if (this.compact && this.tooltip) {
      menuItem = html`<eko-tooltip position="right" arrow>
        ${menuItem} <span slot="content">${this.tooltip}</span>
      </eko-tooltip>`;
    }

    return html`<li class="eko-secondary-nav-item">${menuItem}</li>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-secondary-nav-item": NavigationItem;
  }
}

export default NavigationItem;
